import { render, staticRenderFns } from "./AdminRegisterForm.vue?vue&type=template&id=1f63d241"
import script from "./AdminRegisterForm.vue?vue&type=script&lang=ts"
export * from "./AdminRegisterForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports